import UserDriverListParams from "./user-driver-list-params";
import UserDriverList from "./user-driver-list";
import UserDriverListError from "./user-driver-list-error";
import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";

const useDriverList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserDriverList>({ data: [], totalCount: 0 });

  const load = async (
    params: UserDriverListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const driverList = await userService.getDriverList(params, signal);

      setData(driverList);
    } catch (_error) {
      const error = _error as UserDriverListError;

      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDriverList;
